// extracted by mini-css-extract-plugin
export default {"itemContainer":"ItemsList_itemContainer__lHEII","label":"ItemsList_label__I3tyB","itemList":"ItemsList_itemList__jeAdj"};